import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { retrieveFromLocalStorage } from '../../utils/util';

import { requestSavePreferences } from '../../api/preference/preference.actions';

import MyPreferences from '../../components/screens/my-preferences/MyPreferences';

const MyPreferencesContainer = () => {
  const [preferences, setPreferences] = useState([]);

  const dispatch = useDispatch();

  const updatePreference = (name) => {
    const updatedPreferences = preferences.map((preference) => {
      if (preference.name === name) {
        const value = preference.value === 'true' ? 'false' : 'true';
        return { ...preference, value };
      }
      return preference;
    });

    setPreferences(updatedPreferences);
  };

  useEffect(() => {
    const preferences = retrieveFromLocalStorage('preferences');
    setPreferences(preferences);
  }, []);

  const savePreferences = () => {
    const personExternalReference = retrieveFromLocalStorage('personExternalReference');
    const mappedPreferences = preferences.map((preference) => {
      return {
        ...preference,
        partyExternalReference: personExternalReference,
      };
    });

    dispatch(
      requestSavePreferences({
        input: {
          preferences: mappedPreferences,
        },
      })
    );
  };

  return (
    <MyPreferences preferences={preferences} updatePreference={updatePreference} savePreferences={savePreferences} />
  );
};

export default MyPreferencesContainer;
